import React, { useState, useEffect } from 'react';
import { Document, Page, pdfjs } from 'react-pdf';

// Use fixed version from unpkg
pdfjs.GlobalWorkerOptions.workerSrc = '/pdf.worker.min.js';

const PDFViewer = ({ url, className }) => {
  const [numPages, setNumPages] = useState(null);
  const [pageNumber, setPageNumber] = useState(1);
  const [error, setError] = useState(null);

  const onDocumentLoadSuccess = ({ numPages }) => {
    console.log('“„ PDF loaded:', numPages, 'pages');
    setNumPages(numPages);
    setPageNumber(1);
    setError(null);
  };

  const onDocumentLoadError = (error) => {
    console.error('âŒ PDF load error:', error);
    setError('Failed to load PDF');
  };

  // Auto-advance pages every 5 seconds
  useEffect(() => {
    if (!numPages || numPages === 1) return;

    const interval = setInterval(() => {
      setPageNumber(prev => {
        if (prev >= numPages) return 1;
        return prev + 1;
      });
    }, 5000);

    return () => clearInterval(interval);
  }, [numPages]);

  if (error) {
    return (
      <div className={`${className} flex items-center justify-center bg-gray-900`}>
        <div className="text-center text-white p-8">
          <p className="text-2xl mb-4">âŒ {error}</p>
          <p className="text-sm text-gray-400 mb-2">URL: {url}</p>
          <p className="text-xs text-gray-500">Check if PDF is accessible</p>
        </div>
      </div>
    );
  }

  return (
    <div className={`${className} flex items-center justify-center bg-gray-900 overflow-hidden`}>
      <Document
        file={url}
        onLoadSuccess={onDocumentLoadSuccess}
        onLoadError={onDocumentLoadError}
        loading={
          <div className="text-white text-center">
            <div className="animate-spin rounded-full h-16 w-16 border-b-2 border-white mx-auto mb-4"></div>
            <p className="text-xl">Loading PDF...</p>
          </div>
        }
      >
        <Page 
          pageNumber={pageNumber}
          width={Math.min(window.innerWidth, 1920)}
          height={window.innerHeight}
          renderTextLayer={false}
          renderAnnotationLayer={false}
          className="max-w-full max-h-full"
        />
      </Document>
      
      {numPages && numPages > 1 && (
        <div className="absolute bottom-8 right-8 bg-black/80 text-white px-6 py-3 rounded-lg text-lg">
          Page {pageNumber} of {numPages}
        </div>
      )}
    </div>
  );
};

export default PDFViewer;
